import React, { useState } from 'react';
import { Box, makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import {
  Modal,
  CheckBox,
  DefaultButton,
  Body2Text,
  colors,
} from 'design-system';
import ConsentText from './ConsentText';

const useStyles = makeStyles(() => ({
  container: {
    maxHeight: 392,
    padding: '5px 26px',
    border: '1px solid #D1D0D0',
    overflowY: 'scroll',
    color: colors.abbey,
    fontSize: 15,
    fontWeight: 400,
  },
}));

type Props = {
  onClose: () => void;
  onAccept: () => void;
  open: boolean;
};

const ConsentModal = ({ open, onClose, onAccept }: Props): JSX.Element => {
  const classes = useStyles();
  const [accept, setAccept] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Modal
      data-testid="swi-consent-modal"
      title="Consentimiento informado"
      open={open}
      maxWidth="sm"
      onCloseRequested={onClose}
    >
      <Box className={classes.container}>
        <ConsentText data-testid="informed-consent-text" />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: 'fit-content' }}>
          <CheckBox
            inputId="consentCheck"
            data-testid="consentCheck"
            checkTitle={
              <Body2Text id="swi-consent-text">
                He leído y estoy de acuerdo con los términos y condiciones de
                este sitio.
              </Body2Text>
            }
            checkName="consentCheck"
            defaultValue={accept}
            onChange={(val): void => {
              setAccept(val);
            }}
            style={{ alignItems: 'center', paddingTop: 15 }}
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          data-testid="consent-button-container"
          sx={{ width: isMobile ? '100%' : '50%', mt: '10px' }}
        >
          <DefaultButton
            id="swi-consent-button"
            data-testid="swi-consent-button"
            onClick={onAccept}
            disabled={!accept}
            fullWidth
          >
            Acepto
          </DefaultButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConsentModal;
